import type { ApiApp } from '@app/constants/ApiTypes/internalEntities'

import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'

const appsSlice = createReduxSlice<Record<string, ApiApp>>('apps')

export const appsSelector = createSelector([appsSlice.selector], apps => apps ?? {})

export const setApp = (app: ApiApp) => appsSlice.update(state => ({ ...state, [app.id]: app }))
